import { useTypedParams } from '@sorare/core/src/lib/routing';

import CollectionCardsPage from '@sorare/gameplay/src/components/collections/CardsPage';

import { PageParams } from './__generated__/routeParams';

const CardsPage = () => {
  const { slug, collection } = useTypedParams<PageParams>();

  if (!slug || !collection) {
    return null;
  }

  return <CollectionCardsPage slug={slug} collection={collection} />;
};
export default CardsPage;
